(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.collection-slider', {
      arrows: false,
      rewind: true,
      autoplay: true,
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-left-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.content-left-slider')) {
      new Splide('.content-left-slider').mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-slider"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.section-home-slider', {
      type: 'loop',
      arrows: false,
      pagination: true,
      autoplay: true,
      rewind: true,
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (document.querySelector('.related-list')) {
    const relatedSlider = new Splide('.related-list', {
      type: 'slide',
      arrows: false,
      pagination: false,
      gap: '3rem',
      perPage: 3,
      perMove: 1,
      breakpoints: {
        640: {
          perPage: 1,
        },
        768: {
          perPage: 2,
        },
      },
    });

    const progressBar = relatedSlider.root.querySelector('.section-products-slider__progress-bar');
    relatedSlider.on('mounted move', () => {
      let end = relatedSlider.Components.Controller.getEnd() + 1;
      let rate = Math.min((relatedSlider.index + 1) / end, 1);
      progressBar.style.width = String(100 * rate) + '%';
    });

    relatedSlider.mount();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.blog-list');
    let loading = false;

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.blog-list .blog-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;
          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sortDropdown = document.getElementById('SortBy');
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.product-grid');
    const collectionUrl = document.querySelector('.filters-form').dataset.collectionUrl;
    let loading = false;

    sortDropdown.addEventListener('change', (event) => {
      if (loading) return;
      const selectedSortOption = event.target.value;
      const url = `${collectionUrl}?sort_by=${selectedSortOption}`;
      loading = true;

      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.replaceChildren(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;
          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading sorted products:', error);
          loading = false;
        });
    });

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;

          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sortDropdown = document.getElementById('SortBy');
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.product-grid');
    const collectionUrl = document.querySelector('.filters-form').dataset.collectionUrl;
    let loading = false;

    sortDropdown.addEventListener('change', (event) => {
      if (loading) return;
      const selectedSortOption = event.target.value;
      const url = `${collectionUrl}?sort_by=${selectedSortOption}`;
      loading = true;

      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.replaceChildren(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;
          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading sorted products:', error);
          loading = false;
        });
    });

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;

          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-instant-recipe-article"]) return;
  try {
    
  if (document.querySelector('.related-list')) {
    const relatedSlider = new Splide('.related-list', {
      type: 'slide',
      arrows: false,
      pagination: false,
      gap: '3rem',
      perPage: 3,
      perMove: 1,
      breakpoints: {
        640: {
          perPage: 1,
        },
        768: {
          perPage: 2,
        },
      },
    });

    const progressBar = relatedSlider.root.querySelector('.section-products-slider__progress-bar');
    relatedSlider.on('mounted move', () => {
      let end = relatedSlider.Components.Controller.getEnd() + 1;
      let rate = Math.min((relatedSlider.index + 1) / end, 1);
      progressBar.style.width = String(100 * rate) + '%';
    });

    relatedSlider.mount();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-instant-recipe"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.blog-list');
    let loading = false;

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.blog-list .blog-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More Recipe';
          loadMoreButton.dataset.nextUrl = nextPagination;
          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More Recipe';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const productSlider = new Splide('.product__images', {
  type: 'slide',
  arrows: false,
  pagination: false,
  perPage: 1,
  perMove: 1,
  });
  const productThumbnailSlider = new Splide('.product__thumbnails', {
  fixedWidth: 118,
  fixedHeight: 126,
  gap: 20,
  rewind: true,
  arrows: false,
  pagination: false,
  isNavigation: true,
  });
  productSlider.sync(productThumbnailSlider);

  const progressBar = productThumbnailSlider.root.querySelector('.section-products-slider__progress-bar');
  productSlider.on('mounted move', () => {
  let end = productSlider.Components.Controller.getEnd() + 1;
  let rate = Math.min((productSlider.index + 1) / end, 1);
  progressBar.style.width = String(100 * rate) + '%';
  });
  productSlider.mount();
  productThumbnailSlider.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-pyrex-recipe-article"]) return;
  try {
    
  if (document.querySelector('.related-list')) {
    const relatedSlider = new Splide('.related-list', {
      type: 'slide',
      arrows: false,
      pagination: false,
      gap: '3rem',
      perPage: 3,
      perMove: 1,
      breakpoints: {
        640: {
          perPage: 1,
        },
        768: {
          perPage: 2,
        },
      },
    });

    const progressBar = relatedSlider.root.querySelector('.section-products-slider__progress-bar');
    relatedSlider.on('mounted move', () => {
      let end = relatedSlider.Components.Controller.getEnd() + 1;
      let rate = Math.min((relatedSlider.index + 1) / end, 1);
      progressBar.style.width = String(100 * rate) + '%';
    });

    relatedSlider.mount();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-pyrex-recipe"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.blog-list');
    let loading = false;

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.blog-list .blog-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More Recipe';
          loadMoreButton.dataset.nextUrl = nextPagination;
          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More Recipe';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.product-grid');
    let loading = false;

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;

          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.section-products-slider__slider')) {
      const productSlider = new Splide('.section-products-slider__slider', {
        type: 'loop',
        arrows: false,
        pagination: false,
        autoplay: true,
        rewind: true,
        gap: '3rem',
        perPage: 4,
        perMove: 1,
        breakpoints: {
          640: {
            perPage: 2,
          },
          960: {
            perPage: 2,
          },
          1024: {
            perPage: 3,
          },
        },
      });

      const progressBar = productSlider.root.querySelector('.section-products-slider__progress-bar');
      productSlider.on('mounted move', () => {
        let end = productSlider.Components.Controller.getEnd() + 1;
        let rate = Math.min((productSlider.index + 1) / end, 1);
        progressBar.style.width = String(100 * rate) + '%';
      });

      productSlider.mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-navigation"] && !Shopify.designMode) return;
  try {
    
  // JavaScript for prev and next buttons functionality
  const brandScroll = document.querySelector('.brand-scroll');
  const prevBtn = document.querySelector('.prev');
  const nextBtn = document.querySelector('.next');

  prevBtn.addEventListener('click', () => {
    brandScroll.scrollBy({
      left: -200, // Adjust scroll distance as needed
      behavior: 'smooth',
    });
  });

  nextBtn.addEventListener('click', () => {
    brandScroll.scrollBy({
      left: 200, // Adjust scroll distance as needed
      behavior: 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.location-block__title').forEach((item) => {
    item.addEventListener('click', (e) => {
      let mapId = e.currentTarget.dataset.map;
      document.querySelector('.location-block.active .icon').classList.remove('icon-minus');
      document.querySelector('.location-block.active').classList.remove('active');
      e.currentTarget.querySelector('.icon').classList.toggle('icon-minus');
      document.querySelectorAll('.iframe-map').forEach((map) => map.classList.remove('active'));
      document.getElementById(`${mapId}`).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
